<template>
  <div class="footer-container">
    <p>All copyrights rights reserved ©, 2022 - by Mayank Pant</p>
  </div>
</template>

<style lang="scss" scoped>
.footer-container {
  background-color: #c1c1c1;
  padding: 10px;
  box-shadow: 3px 10px 25px #b9b8b8;
  color: #5b5b5b;
  position: fixed;
  bottom: 0px;
  width: 100%;
  p {
    margin: 0px;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
  }
}
</style>
